export const INVALID_PHONE_TEXT = "bnpl:login.invalid_phone";

// bulwark's code for a new phone number whose order email already belongs to another customer
const EMAIL_REGISTERED_WITH_OTHER_PHONE = "EMAIL_REGISTERED_WITH_OTHER_PHONE";

/**
 * The text to show for a refused login request.
 *
 * Only some of the refusals are about the phone number: an order email that is already
 * registered with another number (409) and a rate limit (429) would send the customer off
 * fixing a number that is fine, so they get their own text.
 */
export function loginErrorText(error) {
  const status = error?.status ?? error?.statusCode;
  if (
    status === 409 &&
    error?.data?.code === EMAIL_REGISTERED_WITH_OTHER_PHONE
  ) {
    return "bnpl:login.email_registered_with_other_phone";
  }
  if (status === 429) {
    return "bnpl:login.too_many_attempts";
  }
  return INVALID_PHONE_TEXT;
}

/**
 * The values the text of a refused login is filled in with, e.g. the last digits of the phone
 * number an order email is registered with (phoneEnding).
 */
export function loginErrorParams(error) {
  return error?.data?.params ?? {};
}
